import React from 'react';
import { Progress } from 'src/shared/components/ui/progress';
import type { RowCommitState } from '../../commit';
import type { PreviewSiteManifestResponse } from '../../state/api/organisationEngineSlice';

const SETTLED: ReadonlyArray<RowCommitState['overallStatus']> = ['created', 'updated', 'failed'];

// Counts settled rows against the engine's pre-commit count of new + update
// rows. Only those two kinds ever reach rowStates — the engine omits unchanged
// rows from the preview and error rows never enter a pipeline — so every row
// here belongs in the numerator. The bar transitions linearly via Radix's
// transform-based indicator.
export const CommitProgressBar = ({
    summaryHint,
    rowStates,
}: {
    summaryHint: PreviewSiteManifestResponse['summary'];
    rowStates: Record<number, RowCommitState>;
}) => {
    const total = summaryHint.new + summaryHint.update;
    const settled = Object.values(rowStates).filter(s => SETTLED.includes(s.overallStatus)).length;
    const percent = total === 0 ? 0 : Math.round((settled / total) * 100);

    return (
        <div data-testid='commit-progress-bar' className='flex flex-col gap-1' aria-live='polite'>
            <div className='flex items-center justify-between text-sm text-grey-70'>
                <span>
                    {settled} of {total} {total === 1 ? 'row' : 'rows'} onboarded
                </span>
                <span className='font-mono' data-testid='commit-progress-percent'>
                    {percent}%
                </span>
            </div>
            <Progress value={percent} aria-label='Onboarding progress' />
        </div>
    );
};
